import { render, staticRenderFns } from "./edit-sgs-modal.vue?vue&type=template&id=bb1305c8"
import script from "./edit-sgs-modal.vue?vue&type=script&lang=js"
export * from "./edit-sgs-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports